import { z } from 'zod';
/**
 * EntityKind — the closed set of dossier kinds the portal routes on.
 *
 * Distinct from `BookmarkType` (customer/person/topic/product/entity) and
 * `OrgPinnedEntityType` (adds 'company'): those are storage-layer
 * discriminators on per-user and per-org pinned rows. EntityKind is the
 * **navigation-layer** alphabet — the kinds that appear in
 * `/dossiers/$kind/$id` URLs and in the `<EntityLink>` primitive that
 * replaces every hand-rolled `<Link to="/dossiers/…">` in v7.
 *
 * Sourced from the v7 design bundle (`docs/designs/v7/chats/chat2.md`
 * §"Entity link system" + `docs/designs/v7/project/shell.jsx` Icon set).
 * Promoting it to a typed enum here keeps client and server in lockstep
 * — the router, the link primitive, and the dossier surfaces all read
 * from the same source rather than hand-typing the same six literals at
 * call sites.
 */
export const EntityKind = z.enum(['person', 'company', 'topic', 'deal', 'product', 'event']);
